// Sticky top chrome: logo + title (with "n minutes ago") on the left,
// close control on the right. Presentational — callbacks forwarded from the orchestrator.

import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import KulaDarkLogo from '@/assets/icons/colored/KulaDarkLogo';
import { capitalizeFirstLetter } from '@/utils/commonHelpers';
import { formatTimeAgo, stripMentionTags } from '../../../helpers';
import { LOGO_SIZE_PX } from '../../constants';
import { WindowControls } from '../WindowControls';
import type { HeaderProps } from './Header.types';

export const Header = ({ title, createdAt, onClose }: HeaderProps) => (
  <Flex
    as="header"
    align="center"
    justify="space-between"
    px="12px"
    py="10px"
    borderBottom="1px solid"
    borderColor="border-color"
    bg="base-white"
    flexShrink={0}
  >
    <Flex align="center" gap="8px" minW={0}>
      <Box
        onClick={onClose}
        display="flex"
        flexShrink={0}
        aria-hidden
        cursor="pointer"
      >
        <KulaDarkLogo width={LOGO_SIZE_PX} height={LOGO_SIZE_PX} />
      </Box>
      <Text truncate className="font-semibold text-secondary-900">
        {capitalizeFirstLetter(stripMentionTags(title))}
      </Text>
      {createdAt ? (
        <Text className="text-secondary-400 shrink-0">
          · {formatTimeAgo(createdAt)}
        </Text>
      ) : null}
    </Flex>
    <WindowControls onClose={onClose} />
  </Flex>
);
